/*
 * Fetch a Query from Objkt's GraphQL API
 */
export const fetchGraphQL = async (operationsDoc: string, operationName: string) : Promise<Record<string, any>> => {
  const result = await fetch(
    'https://data.objkt.com/v2/graphql',
    {
      method: 'POST',
      body: JSON.stringify({
        query: operationsDoc,
        operationName: operationName
      })
    }
  );

  return await result.json();
};

/*
 * returns all new sales info after starting date which includes HEN sales.
 * this means purchases, accepted offers, and completed auctions
 *
 * @param contract - the contract address as a string
 * @param startingDateISOString - the start date an ISO compliant string
 *
 * @return recipient(_id) - the person who got it
 * @return creator(_id) - the person who sold it
 * @return token:creator(_id) - person who made the token
 */
export const getTokenInfoContract = async (id: string, contract: string) : Promise<Record<string, any>> => {
  const query = `
    query MyQuery {
      token(
        where: {
          token_id: {_eq: "${id}"},
          fa: {contract: {_eq: "${contract}"}}
        }
      ) {
        token_id
        name
        display_uri
        fa {
          contract
          path
        }
        royalties {
          amount
          decimals
          receiver_address
        }
      }
    }
  `;
  const json = await fetchGraphQL(query, 'MyQuery');
  return json.data.token[0];
};

/*
 * returns all new sales info after starting date which includes HEN sales.
 * this means purchases, accepted offers, and completed auctions
 *
 * @param contract - the contract address as a string
 * @param startingDateISOString - the start date an ISO compliant string
 *
 * @return recipient(_id) - the person who got it
 * @return creator(_id) - the person who sold it
 * @return token:creator(_id) - person who made the token
 */
export const getTokenInfoPath = async (id: string, path: string) : Promise<Record<string, any>> => {
  const query = `
    query MyQuery {
      token(
        where: {
          token_id: {_eq: "${id}"},
          fa: {path: {_eq: "${path}"}}
        }
      ) {
        token_id
        name
        display_uri
        fa {
          contract
          path
        }
        royalties {
          amount
          decimals
          receiver_address
        }
      }
    }
  `;
  const json = await fetchGraphQL(query, 'MyQuery');
  return json.data.token[0];
};
